import { ORDER_STATUS_ACCEPTED } from '../order-api/order-api-client-constants'

export type OrderStatus = {
  status: string
}

const buildOrderStatus = function () : OrderStatus {
  return {
    status: ORDER_STATUS_ACCEPTED
  }
}

export {
  buildOrderStatus
}



// WEBPACK FOOTER //
// ./src/types/order-status.js